const state = {
  messages: {},
};

const getters = {
  messages: $state => $state.messages,
};

const actions = {
  addErrorMessage({ commit }, message) {
    commit('setMessage', { text: message, kind: 'error' });
  },

  addSuccessMessage({ commit }, message) {
    commit('setMessage', { text: message, kind: 'success' });
  },

  removeMessages({ commit }) {
    commit('setMessage', {});
  },
};

const mutations = {
  setMessage($state, payload) {
    const stateCopy = $state;
    stateCopy.messages = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
